import { useTranslation } from 'react-i18next'
import { ApproachValuesContent } from './ApproachValuesContent'
import { ArchitectureContent } from './ArchitectureContent'
import { CorpusContent } from './CorpusContent'
import { InterfaceContent } from './InterfaceContent'
import { ObjectivesContent } from './ObjectivesContent'
import { PracticeContent } from './PracticeContent'
import { TeamContent } from './TeamContent'

const SECTION_CONTENTS = [
  ApproachValuesContent,
  ObjectivesContent,
  TeamContent,
  InterfaceContent,
  CorpusContent,
  ArchitectureContent,
  PracticeContent,
] as const

type SectionContentProps = { index: number; sectionKey: string }

export function SectionContent({ index, sectionKey }: SectionContentProps) {
  const { t } = useTranslation()

  if (index >= 0 && index < SECTION_CONTENTS.length) {
    const Content = SECTION_CONTENTS[index]
    return <Content />
  }

  return (
    <div className="px-6 pt-2 pb-5">
      <p className="text-foreground text-base leading-relaxed font-normal">
        {t(`${sectionKey}Content`)}
      </p>
    </div>
  )
}
